import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Grid,
  Paper,
  Stack,
  Avatar,
  IconButton,
  Popover,
  List,
  ListItem,
  ListItemText,
  Modal,
} from "@mui/material";
import {
  MoreVert,
  Call,
  VideoCall,
  ArrowBackIosNewOutlined as ArrowBackIosNewOutlinedIcon,
} from "@mui/icons-material";
import CustomizedSnackbars from "../../CustomSnackbar"; // Assuming this is a separate component
import {
  setVideoSwitch,
  handleMenuClick as dispatchMenuClick,
  handleCallUser,
  handleReport,
  chatClickedInCallAction,
  selectedChatAction,
  setSnackbarAction,
  chatOpenAction,
  fetchContactsSuccess,
  fetchContactsRequest,
  updateContacts,
} from "../../../../Store/Buzzcom/actions"; // Example actions
import AcceptRequestDialog from "../../Dialouge";
import StatusBadge from "../StatusBadge";
import apiServices from "../../../../services/apiServices";
import ChatStatusBadge from "../ChatStatusBadge";
// import StyledBadge from "../../../Shared/StyledBadge/styledBadge";

const ChatHeader = (props) => {
  const dispatch = useDispatch();

  // Redux states (global state)
  const snackbarState = useSelector((state) => state.Buzzcom.snackbarState);
  const selectedChat = useSelector((state) => state.Buzzcom.selectedChat);
  const sender = selectedChat?.contacts[0]?.userId.toString();
  const receiver = selectedChat?.contacts[1]?.userId.toString();
  const userIdsArray = useSelector((state) => state.Buzzcom.userIdsArray);
  const chatClickedInCallstate = useSelector(
    (state) => state.Buzzcom.chatClickedInCall
  );
  const handleCall = useSelector((state) => state.Buzzcom.handleCall);

  const contacts = useSelector((state) => state.Buzzcom.contacts);
  const onlineUsers = useSelector((state) => state.Buzzcom.onlineUsers);
  // ----------------------------------------------------------------
  const [selectedChatBlocked, setSelectedChatBlocked] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [reportReason, setReportReason] = useState("");

  // Local states
  const [toggle, setToggle] = useState(false);
  const [imageModal, setImageModal] = useState(false);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [popUpBlock, setPopupBlock] = useState(false);
  const [reportUser, setReportUser] = useState(false);
  const [popUpDelete, setPopUpDelete] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [videoSwitch, setVideoSwitchState] = useState(false);
  const [camOff, setCamOff] = useState({ my: false, other: false });
  const openUser = Boolean(anchorElUser);

  // Methods
  const handleClickUser = (e) => {
    setAnchorElUser(e.currentTarget);
  };

  // Popover-related
  const openUserPopover = Boolean(anchorElUser);
  const userPopoverId = openUserPopover ? "user-popover" : undefined;

  const handleSnackbarClose = () => {
    dispatch({ type: "CLOSE_SNACKBAR" });
  };

  const handleMenuClick = (e, type) => {
    setAnchorElUser(e.currentTarget);
    setMenuOpen(type);
  };

  const handleCloseUser = () => {
    setAnchorElUser(null);
  };

  const toggleChat = () => {
    setToggle(false);
    dispatch(chatClickedInCallAction(null));
  };

  const handleBlock = async () => {
    let obj = {
      conversationId: selectedChat?.conversationId,
      requestedBy: selectedChat?.requestedBy,
      isBlocked: selectedChat?.status == "accepted" ? true : false,
    };

    let response = await apiServices.blockContact(obj);
    if (response?.status === 200) {
      dispatch(
        setSnackbarAction({
          status: "success",
          show: true,
          message: response?.data?.message,
        })
      );
      // alert(response?.data?.message);
      const payload = {
        requestedBy: localStorage.getItem("userId"),
      };
      dispatch(fetchContactsRequest(payload));
      dispatch(selectedChatAction(null));
      dispatch(chatOpenAction(false));
    } else {
      dispatch(
        setSnackbarAction({
          status: "success",
          show: true,
          message: response?.data?.message,
        })
      );
    }
    setPopupBlock(false);
  };

  const handleReport = async () => {
    let objReport = {
      from: sender,
      against: receiver,
      conversationId: selectedChat?.conversationId,
      reportType: "dispute",
      report: reportReason,
    };

    let response = await apiServices.createReport(objReport);

    if (response?.status == "200") {
      // setChattingContactApi(true);
      setReportReason("");
      dispatch(
        setSnackbarAction({
          status: "success",
          show: true,
          message: response?.data?.message,
        })
      );
      // alert(response?.data?.message);
    } else {
      dispatch(
        setSnackbarAction({
          status: "error",
          show: true,
          message: response?.data?.message,
        })
      );
      // alert(response?.response?.data?.message);
    }
    setReportUser(false);
  };

  const handleDeleteContact = async () => {
    let obj = {
      requestedBy: selectedChat?.requestedBy,
      conversationId: selectedChat?.conversationId,
    };

    // if (addedContactIds.includes(message.contacts[1].userId)) {
    //   const updatedContactIds = addedContactIds.filter(
    //     (id) => id !== message.contacts[1].userId
    //   );
    //   setAddedContactIds(updatedContactIds);
    // }
    let response = await apiServices.deleteContact(obj);
    if (response?.status === 404) {
      dispatch(
        setSnackbarAction({
          status: "error",
          message: response?.data?.message || "Contact Not Found",
          show: true,
        })
      );
      dispatch(chatOpenAction(false));
      dispatch(selectedChatAction(null));
    } else if (!response?.data?.error) {
      dispatch(chatOpenAction(false));
      dispatch(selectedChatAction(null));
      const payload = {
        requestedBy: localStorage.getItem("userId"),
      };
      dispatch(fetchContactsRequest(payload));
      dispatch(
        setSnackbarAction({
          status: "success",
          message: response?.data?.message || "Contact Deleted Successfully",
          show: true,
        })
      );
    }
    setPopUpDelete(false);
  };
  //   HOOKS
  useEffect(() => {
    console.log(">>>selectedChat???", selectedChat);
    let isUpdated = false;
    // const alterConversationId = selectedChat?.conversationId
    //   .split(".")
    //   .reverse()
    //   .join(".");
    // alterConversationId &&
    //   apiServices
    //     .filterContact(null, null, alterConversationId)
    //     .then((data) => {
    //       console.log("DATA_FOUND_FOR_CHAT", data);
    //       const newData = data?.data[0];
    if (selectedChat?.status === "blocked") {
      // isUpdated = true;
      setSelectedChatBlocked(true);
    }
    if (selectedChat?.status === "accepted") {
      // isUpdated = true;
      setSelectedChatBlocked(false);
    }
    console.log("updatedSelectedChat?", selectedChat);
    // });
  }, [selectedChat]);

  useEffect(() => {
    if (chatClickedInCallstate) {
      setToggle(true);
    }
    return () => {
      setToggle(false);
      dispatch(chatClickedInCallAction(null));
    };
  }, [chatClickedInCallstate, selectedChat]);

  console.log("selectedChat", onlineUsers);
  // ? onlineUsers?.includes(selectedChat?.contacts[1]?.userId)

  return (
    <div className="chat-header">
      <div className="row">
        <ChatStatusBadge
          contact={selectedChat}
          memoizedUserIdsArray={userIdsArray}
          status={
            selectedChat &&
            selectedChat?.status !== "blocked" &&
            onlineUsers?.includes(selectedChat?.contacts[1]?.userId)
          }
        />
      </div>
      <div className="chatheader-info" style={{ marginLeft: "15px" }}>
        <p
          className="m-0 p-0 pt-3"
          style={{
            fontSize: "16px",
            fontWeight: "600",
          }}
        >
          {selectedChat?.contacts[1].userName}
        </p>
        <p className="m-0 p-0 pb-1">
          <span
            style={{
              fontSize: "12px",
              fontWeight: "400",
              color: "white",
              // selectedChat &&
              // selectedChat?.status !== "blocked" &&
              // !selectedChatBlocked
              //   ? userIdsArray?.includes(selectedChat?.contacts[1]?.userId)
              //     ? "#18E448"
              //     : "#CCCCCC"
              //   : "#CCCCCC",

              //     // : "#CCCCCC",
            }}
          >
            {" "}
            {selectedChat && selectedChat?.status !== "blocked"
              ? onlineUsers?.includes(selectedChat?.contacts[1]?.userId)
                ? "Online"
                : "Offline"
              : "blocked"}
          </span>
        </p>

        {/* You can update your UI based on the isTyping state */}
      </div>
      {toggle ? (
        <div
          className="header-icons"
          style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "20px",
              display: "flex",
            }}
          >
            <IconButton onClick={toggleChat}>
              <ArrowBackIosNewOutlinedIcon style={{ fontSize: "14px" }} />
            </IconButton>
          </div>
        </div>
      ) : (
        <div
          className="header-icons"
          style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#f1f1f1",
              // paddingTop: "4px",
              borderRadius: "8px",
              height: "37px",
              width: "90px",
            }}
          >
            <div className="colorIcon">
              <IconButton
                onClick={(e) => {
                  // handleMenuClick(e, "video");
                  setCamOff((prev) => ({
                    ...prev,
                    my: true,
                    other: false,
                  }));
                  e.stopPropagation();
                  if (handleCall.type === "video") {
                    dispatch(handleCallUser({}));
                    setTimeout(() => {
                      dispatch(handleCallUser({ type: "video" }));
                    }, 0);
                  } else {
                    dispatch(handleCallUser({ type: "video" }));
                  }
                  // if (handleCall.type !== "video") {
                  //   dispatch(handleCallUser({ type: "video" }));
                  // } else {
                  //   dispatch(handleCallUser({}));
                  // }
                }}
              >
                {/* <VideoCall style={{ color: "#ff6500" }} /> */}
                <img src="/video.svg" alt="" />
              </IconButton>
            </div>
            <div className="vertical-divider"></div>
            <div className="colorIcon">
              <IconButton
                onClick={(e) => {
                  // handleMenuClick(e, "audio");
                  e.stopPropagation();
                  if (handleCall.type === "audio") {
                    dispatch(handleCallUser({}));
                    setTimeout(() => {
                      dispatch(handleCallUser({ type: "audio" }));
                    }, 0);
                  } else {
                    dispatch(handleCallUser({ type: "audio" }));
                  }
                }}
              >
                {/* <Call /> */}
                <img src="/call.svg" alt="" />
              </IconButton>
            </div>
          </div>
          <IconButton
            style={{
              paddingRight: 0,
              paddingLeft: "12px",
            }}
          >
            <MoreVert
              sx={{ color: "#ffffff" }}
              onClick={(e) => {
                handleClickUser(e); // Trigger context menu manually
              }}
            />
          </IconButton>
          <Popover
            id={id}
            open={openUser}
            anchorEl={anchorElUser}
            onClose={handleCloseUser}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <List>
              <ListItem
                // buttonfal
                onClick={() => {
                  setPopupBlock(true);
                  handleCloseUser();
                }}
              >
                <ListItemText
                  primary={
                    selectedChat?.status == "accepted"
                      ? "Block User"
                      : "Unblock User"
                  }
                />
              </ListItem>

              <ListItem
                button
                onClick={() => {
                  setReportUser(true);
                  handleCloseUser();
                }}
              >
                <ListItemText primary="Report User" />
              </ListItem>
              <ListItem
                button
                onClick={() => {
                  setPopUpDelete(true);
                  handleCloseUser();
                }}
              >
                <ListItemText primary="Delete User" />
              </ListItem>
            </List>
          </Popover>
        </div>
      )}
      <AcceptRequestDialog
        reportUser={true}
        cancelText="Cancel"
        acceptText="Report User"
        title="Report User"
        reportReason={reportReason}
        setReportReason={setReportReason}
        text="Are you sure you want to report the user ?"
        open={reportUser}
        onClose={() => setReportUser(false)}
        onAccept={handleReport}
      />

      <AcceptRequestDialog
        cancelText="No"
        acceptText="Yes"
        title={"Block User"}
        text={`Are you sure you want to Block User?`}
        open={popUpBlock}
        onClose={() => setPopupBlock(false)}
        onAccept={handleBlock}
      />

      <AcceptRequestDialog
        cancelText="No"
        acceptText="Yes"
        title={"Delete Contact"}
        text={`Are you sure you want to delete the contact ?`}
        open={popUpDelete}
        onClose={() => {
          setPopUpDelete(false);
        }}
        onAccept={() => handleDeleteContact(selectedChat)}
      />
    </div>
  );
};

export default ChatHeader;
